































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Layout from '../Forum/Layout.vue';
import Post from '../Forum/Post.vue';
@Component
@Component({
  components: {
    Layout,
    Post,
  },
})
export default class CommunityForum extends Vue {
  mounted() {
    vxm.forum.loadPosts({ initCall: true });
  }
  get postList() {
    return vxm.forum.PostList;
  }
}
